import { render, staticRenderFns } from "./WaitTimeList.vue?vue&type=template&id=0686a712"
import script from "./WaitTimeList.vue?vue&type=script&lang=js"
export * from "./WaitTimeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports